import { APIOrgTripleAttributes, OrgTriple } from '@ardoq/api-types';
import { crudApi, fetchJson, Method, toRequestOptions } from './api';
import { ApiResponse } from './types';
import { resultsToPayloadOrError } from '@ardoq/common-helpers';

const generateDescription = async (
  body: OrgTriple
): ApiResponse<{
  text: string;
  type: 'description' | 'excuse';
}> => {
  const request = new Request(
    `/api/org-triple/autocomplete/description`,
    toRequestOptions(Method.POST, body)
  );
  return fetchJson(request);
};

const createMultiple = async (payload: {
  items: Omit<OrgTriple, 'description'>[];
}): ApiResponse<APIOrgTripleAttributes[]> => {
  const results = await Promise.all(
    payload.items.map(({ sourceType, referenceType, targetType }) =>
      orgTripleApi.create({
        sourceType,
        referenceType,
        targetType,
        description: '',
      })
    )
  );

  return resultsToPayloadOrError(results);
};

const deleteMultiple = async (tripleIds: string[]): ApiResponse<string[]> => {
  const results = await Promise.all(
    tripleIds.map(tripleId => orgTripleApi.delete(tripleId))
  );

  return resultsToPayloadOrError(results);
};

export const orgTripleApi = {
  ...crudApi<APIOrgTripleAttributes, OrgTriple>('org-triple'),
  generateDescription,
  createMultiple,
  deleteMultiple,
};
